(() => {
  function init() {
    const host = document.getElementById("therabody-purchase-popup");
    if (!host || host.dataset.ready) return;
    host.dataset.ready = "true";

    const dismissalKey = "therabody-purchase-dismissed";

    try {
      if (sessionStorage.getItem(dismissalKey)) return;
    } catch (_) {}

    const source = host.querySelector("template[data-purchase-feed]");
    if (!source) return;

    let feed;

    try {
      feed = JSON.parse(source.content.textContent);
    } catch (_) {
      return;
    }

    const refreshed = Date.parse(feed.updatedAt);

    function freshFeed() {
      const age = Date.now() - refreshed;
      return Number.isFinite(refreshed) &&
        age >= -300000 &&
        age <= 2 * 3600000;
    }

    if (!freshFeed()) return;

    const rows = Array.isArray(feed.purchases) ? feed.purchases : [];
    let stopped = false;
    let timer;
    let index = 0;
    let count = 0;

    const shadow = host.attachShadow({ mode: "open" });
    const style = document.createElement("style");

    style.textContent = `
      :host {
        font-family: Arial, sans-serif;
      }

      .card {
        display: flex;
        gap: 12px;
        align-items: center;
        background: #fffdf8;
        color: #202c24;
        border: 1px solid #e7e6db;
        border-radius: 14px;
        padding: 16px 38px 16px 14px;
        box-shadow: 0 8px 28px #19302420;
      }

      .card[hidden] {
        display: none;
      }

      img {
        width: 60px;
        height: 64px;
        flex-shrink: 0;
        object-fit: contain;
        background: #eeeae1;
        border-radius: 8px;
      }

      .copy {
        min-width: 0;
        overflow-wrap: anywhere;
      }

      .person {
        font-size: 12px;
        color: #617068;
        margin-bottom: 5px;
      }

      a {
        font-size: 14px;
        line-height: 1.4;
        font-weight: 600;
        color: inherit;
        text-decoration: none;
      }

      .date {
        font-size: 11px;
        color: #617068;
        margin-top: 7px;
      }

      button {
        position: absolute;
        right: 0;
        top: 0;
        min-width: 44px;
        min-height: 44px;
        background: none;
        border: 0;
        font-size: 20px;
        cursor: pointer;
        color: #617068;
      }

      a:focus-visible,
      button:focus-visible {
        outline: 2px solid #233c32;
      }
    `;

    const card = document.createElement("aside");
    card.className = "card";
    card.hidden = true;
    card.setAttribute("aria-label", "Recent purchase");

    const image = document.createElement("img");
    image.alt = "";
    image.onerror = () => {
      image.hidden = true;
    };

    const copy = document.createElement("div");
    copy.className = "copy";

    const person = document.createElement("div");
    person.className = "person";

    const product = document.createElement("a");

    const date = document.createElement("div");
    date.className = "date";

    const close = document.createElement("button");
    close.type = "button";
    close.textContent = "×";
    close.setAttribute("aria-label", "Dismiss purchase notifications");

    close.onclick = () => {
      stopped = true;
      clearTimeout(timer);
      card.hidden = true;

      try {
        sessionStorage.setItem(dismissalKey, "1");
      } catch (_) {}
    };

    copy.append(person, product, date);
    card.append(image, copy, close);
    shadow.append(style, card);

    host.style.setProperty(
      "--purchase-mobile-offset",
      `${Number(host.dataset.offset) || 80}px`
    );

    function safeURL(value, isImage = false) {
      if (typeof value !== "string" || !value) return null;

      try {
        const url = new URL(value, location.origin);

        if (isImage) {
          return url.protocol === "https:" &&
            url.hostname === "cdn.shopify.com"
            ? url.href
            : null;
        }

        return url.origin === location.origin ? url.href : null;
      } catch (_) {
        return null;
      }
    }

    function show() {
      if (stopped || count >= 5 || !freshFeed()) return;

      if (document.hidden) {
        timer = setTimeout(show, 3000);
        return;
      }

      const eligible = rows.filter(row => {
        if (!row) return false;
        const age = Date.now() - Date.parse(row.purchasedAt);

        return age >= 0 &&
          age <= 7 * 86400000 &&
          safeURL(row.url);
      });

      if (!eligible.length) return;

      const row = eligible[index++ % eligible.length];
      count++;

      const name = host.dataset.showName === "true"
        ? row.customer || "Customer"
        : "Customer";

      person.textContent = `${name} in Singapore`;
      product.textContent = `Purchased ${row.product}`;
      product.href = safeURL(row.url);

      date.textContent = "Purchased on " +
        new Intl.DateTimeFormat("en-SG", {
          day: "numeric",
          month: "short",
          year: "numeric",
          timeZone: "Asia/Singapore"
        }).format(new Date(row.purchasedAt));

      const imageURL = safeURL(row.image, true);
      image.hidden = !imageURL;

      if (imageURL) {
        image.src = imageURL;
      }

      card.hidden = false;

      timer = setTimeout(
        hide,
        (Number(host.dataset.duration) || 6) * 1000
      );
    }

    function hide() {
      if (stopped) return;

      if (shadow.activeElement) {
        timer = setTimeout(hide, 3000);
        return;
      }

      card.hidden = true;
      timer = setTimeout(show, 12000);
    }

    timer = setTimeout(show, 5000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();